import { localized, t } from '@weavedev/lit-i18next';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { global, GlobalComponentType } from '@/context';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles, quantityDetailsStyles } from '@/styles';
import { getCountryCode } from '@/utils';
import { consume } from '@lit/context';

@customElement('fg-quantity-in-option')
@localized()
export class FgQuantityInOption extends LitElement {
  @property({ type: Number })
  inOption?: number;

  @state()
  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  render() {
    if (!this.inOption || this.inOption === 0) {
      return;
    }

    return html`
      <div class="in-option">
        <span>${t('labels.inOption')}:</span>
        <span class="in-option-quantity">
          +${Intl.NumberFormat(
            getCountryCode(this.globalContext.locale),
          ).format(this.inOption)}
        </span>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    quantityDetailsStyles,
    css`
      .in-option {
        font-size: 1rem;
      }

      .in-option-quantity {
        margin-right: 15px;
      }

      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        .in-option {
          font-size: 0.875rem;
        }
      }
    `,
  ];
}
